import React, { useEffect, useState } from 'react'
import locales, { preffixFallbacks } from 'common/locales'

import LocaleContext from 'common/contexts/locale'

function TranslationLoader({ locale, children }) {
  const [translations, setTranslations] = useState(null)
  const mountedRef = React.useRef(true)

  useEffect(() => {
    const localeCode = (locale || 'EN_GB').toUpperCase()
    let load = locales[localeCode]

    if (!load) {
      const [preffix] = localeCode.split('_')
      load = locales[preffixFallbacks[preffix]]
    }

    if (!load) {
      load = locales['EN_GB']
    }

    load().then(translations => {
      if (mountedRef.current) {
        setTranslations(translations)
      }
    })

    return () => {
      mountedRef.current = false
    }
  }, [])

  if (!translations) {
    return null
  }

  return <LocaleContext.Provider value={translations}>{children}</LocaleContext.Provider>
}

export default TranslationLoader
